import { usersRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useUsersCsvImportByEntityType = () =>
  useMutation<void, unknown, FormData>((data) => usersRepo.csvUserImport(data));
